import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class PdpOfferPriceSyncIssueApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.OfferPriceSyncIssue;

  constructor(private label: string) {}

  getPayload(): any {
    return {
      label: this.label
    };
  }
}
